(function () {
  'use strict';

  var FADE_THRESHOLD = 450; // px — fade starts when next block's top is this far above the heading's sticky bottom, ramps to 0 as it reaches it
  var FADE_DELAY = -100; // px — shifts the fade window; positive values keep heading visible longer past the sticky line

  // --- Hash-based deep link: hide → position → reveal ---
  // The inline script in the Liquid template locks scroll and hides the section
  // before it renders. This JS unlocks scroll, positions, and reveals.
  var hashTarget = window.location.hash ? window.location.hash.substring(1) : '';
  var didDeepLink = false;

  function cleanupDeepLink() {
    document.documentElement.style.overflow = '';
    if (history.scrollRestoration) history.scrollRestoration = 'auto';
    var hideEl = document.getElementById('collection-deep-link-hide');
    if (hideEl) hideEl.remove();
  }

  function handleDeepLink(section, blocks, dots) {
    if (!hashTarget) return false;

    var target = document.getElementById(hashTarget);
    if (!target || !target.classList.contains('CollectionDefault__collection-block')) {
      cleanupDeepLink();
      return false;
    }

    // Unlock scroll and position — scroll-margin-top in CSS handles the header offset
    document.documentElement.style.overflow = '';
    target.scrollIntoView({ behavior: 'instant', block: 'start' });

    // Set correct active dot — clear all first, then activate target
    if (dots.length) {
      var targetIndex = Array.prototype.indexOf.call(blocks, target);
      if (targetIndex >= 0 && dots[targetIndex]) {
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.remove('active');
          dots[d].removeAttribute('aria-current');
        }
        dots[targetIndex].classList.add('active');
        dots[targetIndex].setAttribute('aria-current', 'true');
      }
    }

    // Reveal with fade-in
    requestAnimationFrame(function () {
      section.style.transition = 'opacity 0.3s ease';
      section.style.opacity = '1';
      // Clean up the hide style
      var hideEl = document.getElementById('collection-deep-link-hide');
      if (hideEl) hideEl.remove();
      // Clear inline styles after transition and restore scroll restoration
      setTimeout(function () {
        section.style.transition = '';
        section.style.opacity = '';
        if (history.scrollRestoration) history.scrollRestoration = 'auto';
      }, 350);
    });

    return true;
  }

  function init() {
    var section = document.querySelector('.CollectionDefault');
    if (!section) {
      cleanupDeepLink();
      return;
    }

    var blocks = section.querySelectorAll('.CollectionDefault__collection-block');
    if (blocks.length === 0) {
      cleanupDeepLink();
      return;
    }

    var progressBar = section.querySelector('[data-collection-progress]');
    var dots = [];

    if (progressBar && blocks.length > 1) {
      dots = setupProgressDots(progressBar, blocks);
    }

    // Handle hash deep link before anything else
    didDeepLink = handleDeepLink(section, blocks, dots);

    var ticking = false;
    var activeIndex = 0;

    // If we deep-linked, set the initial activeIndex to match
    if (didDeepLink && hashTarget) {
      var target = document.getElementById(hashTarget);
      if (target) {
        activeIndex = Array.prototype.indexOf.call(blocks, target);
        if (activeIndex < 0) activeIndex = 0;
      }
    }

    function onScroll() {
      var headerHeight = getHeaderHeight();
      var currentIndex = 0;
      // On mobile (≤820px) the heading sticks at top:0, not below the header
      var stickyTop = window.innerWidth <= 820 ? 0 : headerHeight;

      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        var heading = block.querySelector('.CollectionDefault__block-heading');
        var blockRect = block.getBoundingClientRect();

        // Sticky heading fade-out — never show two headings at once
        if (heading) {
          var headingHeight = heading.offsetHeight;
          var opacity = 1;

          if (i < blocks.length - 1) {
            // Fade as the next block's top approaches this heading's sticky position
            var nextBlockTop = blocks[i + 1].getBoundingClientRect().top;
            var distance = nextBlockTop - stickyTop - headingHeight + FADE_DELAY;

            if (distance < FADE_THRESHOLD && distance > 0) {
              opacity = distance / FADE_THRESHOLD;
            } else if (distance <= 0) {
              opacity = 0;
            }
            console.log(
              '[fade]',
              'i=' + i,
              'nextBlockTop=' + nextBlockTop.toFixed(0),
              'stickyTop=' + stickyTop,
              'headingHeight=' + headingHeight,
              'distance=' + distance.toFixed(0),
              'opacity=' + opacity.toFixed(2)
            );
          } else {
            // Last block — fade when block bottom approaches
            var distance = blockRect.bottom - stickyTop - headingHeight;
            if (distance < FADE_THRESHOLD && distance > 0) {
              opacity = distance / FADE_THRESHOLD;
            } else if (distance <= 0) {
              opacity = 0;
            }
          }

          heading.style.opacity = opacity;
        }

        // Progress tracking — find the topmost block whose top has scrolled past the header
        if (blockRect.top < headerHeight + 200) {
          currentIndex = i;
        }
      }

      // Update active dot
      if (currentIndex !== activeIndex && dots.length) {
        dots[activeIndex].classList.remove('active');
        dots[activeIndex].removeAttribute('aria-current');
        dots[currentIndex].classList.add('active');
        dots[currentIndex].setAttribute('aria-current', 'true');
        activeIndex = currentIndex;
      }

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Show/hide progress bar when section enters/leaves the viewport
    if (progressBar) {
      var sectionObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          progressBar.style.opacity = entry.isIntersecting ? '1' : '0';
          progressBar.style.pointerEvents = entry.isIntersecting ? '' : 'none';
        },
        { threshold: 0, rootMargin: '0px 0px -100px 0px' }
      );
      sectionObserver.observe(section);
    }

    // Run once on load
    onScroll();
  }

  function getHeaderHeight() {
    var stickyHeader = document.querySelector('sticky-header');
    return stickyHeader ? stickyHeader.offsetHeight || 70 : 70;
  }

  function setupProgressDots(progressBar, blocks) {
    var stepsWrap = progressBar.querySelector('[data-collection-progress-steps]');
    if (!stepsWrap) return [];

    var dots = [];

    for (var i = 0; i < blocks.length; i++) {
      (function (block, index) {
        var heading = block.querySelector('.CollectionDefault__block-heading');
        var label = heading ? heading.textContent.trim() : 'Section ' + (index + 1);

        var dot = document.createElement('span');
        dot.classList.add('CollectionDefault__progress-dot');
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-label', label);
        if (index === 0) {
          dot.classList.add('active');
          dot.setAttribute('aria-current', 'true');
        }

        var scrollToBlock = function () {
          block.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };

        dot.addEventListener('click', scrollToBlock);
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            scrollToBlock();
          }
        });

        stepsWrap.appendChild(dot);
        dots.push(dot);
      })(blocks[i], i);
    }

    progressBar.removeAttribute('hidden');
    return dots;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
